import React from 'react';
import { Capsule, CapsuleProps } from './Capsule';
import TickMarkIcon from '~/assets/icons/tick-mark.svg';
import LanguageIcon from '~/assets/icons/language.svg';
import PlaybackSpeedIcon from '~/assets/icons/playback-speed.svg';

export const TickMarkCapsule = (props: CapsuleProps) => (
  <Capsule {...props}>
    <TickMarkIcon />
  </Capsule>
);

export const LanguageCapsule = (props: CapsuleProps) => (
  <Capsule {...props}>
    <LanguageIcon />
  </Capsule>
);

export const PlaybackSpeedCapsule = (props: CapsuleProps) => (
  <Capsule {...props}>
    <PlaybackSpeedIcon />
  </Capsule>
);
